import { FunctionComponent } from 'react'
import styled, { useTheme } from 'styled-components'
import SvgIcon from '@components/SvgIcon'

const StyledVideoInfoBig = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  line-height: 0;
  display: grid;
  align-items: center;
  justify-items: center;
`

const StyledVideoIconWrapper = styled.div`
  border-radius: 2px;
  width: 20px;
  height: 20px;
  display: grid;
  align-items: center;
  justify-items: center;
  overflow: hidden;
  background-color: ${({
    theme: {
      colors: {
        brandColors: { brand_55 },
      },
    },
  }) => brand_55};
`

const VideoInfoBig: FunctionComponent = () => {
  const theme = useTheme()

  return (
    <StyledVideoInfoBig>
      <StyledVideoIconWrapper>
        <SvgIcon iconName="video-play" size={20} color={theme.colors.white} />
      </StyledVideoIconWrapper>
    </StyledVideoInfoBig>
  )
}

export default VideoInfoBig
